module.exports = __webpack_public_path__ + "img/microneedling-treatment-desktop-fr.b190abc9.jpg";